AoPS.Utils.initKeyChain(AoPS, "Careers", "Views");

AoPS.Careers.Views = (function (Views) {
	// - Declare the basic boilerplate that we use in almost
	// every view.
	// - Wrap the guts of those "basic" functions in helper
	// methods so extending classes can use them if they need
	// to override initialize or render
	// - Make sure pre- and post- hook methods always exist
	Views.Base = AoPS.View.extend({
		tplSlug: "#careers-tpl-",
		tplVars: {},
		initialize: function (options) {
			this.preinitializeHelper(options);
			this.setOptions(options);
			this.postinitializeHelper(options);
			this.render();
		},
		setOptions: function (options) {
			this.options = options;
			if (options.router) {
				this.router = options.router;
			}
			if (options.master) {
				this.master = options.master;
			}
			if (options.jobBoardView) {
				this.jobBoardView = options.jobBoardView;
			}
		},
		render: function () {
			return this.doRender();
		},
		doRender: function () {
			// the guts of the render
			this.prerenderHelper();
			this.$el.html(this.getTemplate(this.getTemplateId(), this.tplVars));
			this.postrenderHelper();
			AoPS.fixSidebarAnimatedOnce(300);
			return this;
		},
		preinitializeHelper: function () {
			// noop in base
		},
		postinitializeHelper: function () {
			// noop in base
		},
		prerenderHelper: function () {
			// noop in base
		},
		postrenderHelper: function () {
			// noop in base
		},
		getTemplateId: function () {
			return this.tplSlug + this.template_id;
		},
		navigate: function (url) {
			this.router.navigate(url, {trigger: true});
		},
	});

	Views.Main = Views.Base.extend({
		template_id: "main",
		preinitializeHelper: function (options) {
			this.model.set("jobSlug", options.slug);
			if (this.model.get("jobBoard").get("jobs").length < 1) {
				this.model.set("viewName", "NoJobs");
			} else {
				this.model.set("viewName", options.viewName);
			}
		},
		postrenderHelper() {
			var options = {
				master: this.model,
				model: this.model.getViewModel(),
				router: this.router,
			};
			this.innerView = new Views[this.model.get("viewName")](options);
			this.$("#careers-page-container").html(this.innerView.$el);
		},
	});

	Views.JobBoard = Views.Base.extend({
		template_id: "job-board-shell",
		prerenderHelper: function () {
			if (this.model.get("jobs").length < 1) {
				this.master.set("viewName", "NoJobs");
			}
			this.tplVars = {
				topWords: this.model.get("topWords"),
				bottomWords: JSON.parse(AoPS.bd.careersBottom),
			};
		},
		postrenderHelper: function () {
			this.$filterContainer = this.$("#job-board-controls");
			this.$listingContainer = this.$("#job-board-listings");
			this.renderFilters();
			this.renderListings();
		},
		renderFilters: function () {
			this.$filterContainer.empty();
			var opts = {
				master: this.master,
				jobBoardView: this,
				router: this.router,
			};
			this.model.get("filters").each(function (filter) {
				if (filter.get("filterDisplayItems").length > 1) {
					opts.model = filter;
					var filterView = new Views.Filter(opts);
					this.$filterContainer.append(filterView.$el);
				}
			}, this);
		},
		renderListings: function () {
			this.$listingContainer.empty();
			var displayBy = this.model.get("displayBy");
			var groups = this.model.get(displayBy).getActiveGroups();
			var openings = this.model.getFilteredJobs();

			var opts = {
				master: this.master,
				jobBoardView: this,
				displayBy: displayBy,
				router: this.router,
			};

			if (openings.length) {
				groups.each(function (group) {
					opts.model = group;
					var listingGroupView = new Views.OpeningGroup(opts);
					this.$listingContainer.append(listingGroupView.$el);
				}, this);
			} else {
				opts.model = this.model;
				var noJobsFilterView = new Views.NoJobsFilter(opts);
				this.$listingContainer.append(noJobsFilterView.$el);
			}
		},
	});

	Views.Filter = Views.Base.extend({
		tagName: "select",
		className: "grnhse-filter",
		template_id: "filter",
		events: {
			change: "handleUpdateFilter",
		},
		prerenderHelper: function () {
			this.tplVars = {
				defaultText: this.model.get("defaultText"),
				filterId: this.model.get("key"),
				options: this.model.get("filterDisplayItems"),
			};
		},
		handleUpdateFilter: function (e) {
			var selected = [];
			if (e.target.selectedIndex) {
				selected = e.target.selectedOptions;
			}
			this.model.updateFilter(selected);
			this.jobBoardView.renderListings();
		},
	});

	Views.OpeningGroup = Views.Base.extend({
		template_id: "board-group",
		postinitializeHelper: function (options) {
			this.openings = options.openings;
			this.displayBy = options.displayBy;
		},
		prerenderHelper: function () {
			this.tplVars = {
				groupName: this.model.get("name"),
			};
		},
		postrenderHelper: function () {
			this.$openingContainer = this.$(".job-opening-container");
			this.model.getJobsForGroup();
			this.renderOpenings();
		},
		renderOpenings: function () {
			this.$openingContainer.empty();
			var opts = {
				master: this.master,
				jobBoardView: this.jobBoardView,
				router: this.router,
			};

			var openings = this.model.getJobsForGroup();

			openings.each(function (opening) {
				opts.model = opening;
				var openingView = new Views.Opening(opts);
				this.$openingContainer.append(openingView.$el);
			}, this);
		},
	});

	Views.Opening = Views.Base.extend({
		template_id: "board-opening",
		className: "grnhse-opening-li",
		tagName: "div",
		events: {
			click: "handleOpeningClick",
		},
		prerenderHelper: function () {
			var remoteTag = this.model.getRemoteTag();
			this.hasMultiplePosts = this.model.get("filteredEquivalents").length > 1;
			this.tplVars = {
				urlPath: this.model.getUrlPath(),
				openingTitle: this.model.get("title"),
				locationName: this.hasMultiplePosts
					? "Multiple"
					: this.model.getPrimaryOfficeLocation(),
				positionType: this.model.getTimeStatus(),
				allowsRemote: !!remoteTag,
				remoteTag: remoteTag,
			};
		},
		handleOpeningClick: function (e) {
			// don't reload - we don't need to
			e.preventDefault();
			if (!this.hasMultiplePosts) {
				this.goToOpening(this.model.get("postSlug"));
			} else {
				var jobs = this.model.collection.getFilteredCollection(
					this.model.get("filteredEquivalents")
				);

				var $el = $(
					"<div>We have <b>" +
						this.model.get("title") +
						"</b> openings in multiple locations.  Please select a location to view the correct opening.<br><br></div>"
				);

				jobs.each(function (job) {
					var postSlug = job.get("postSlug");
					var loc = job.getPrimaryOfficeLocation();
					var $btn = $(
						'<div class="btn btn-primary loc-select" data-slug="' +
							postSlug +
							'">' +
							loc +
							"</div>"
					);
					$el.append($btn);
				});
				AoPS.Ui.Modal.showMessage($el, {
					title: "Select A Location:",
					scrollable: true,
				});
				$el.on(
					"click .loc-select",
					_.bind(function (event) {
						this.goToOpening($(event.target).data("slug"));
					}, this)
				);
			}
		},
		goToOpening: function (slug) {
			this.navigate("job/" + slug);
		},
	});

	Views.JobPost = Views.Base.extend({
		template_id: "job-post-shell",
		postrenderHelper: function () {
			this.$openingContainer = this.$("#job-opening-container");
			this.renderOpening();
		},
		renderOpening: function () {
			this.$openingContainer.empty();
			var opts = {
				master: this.master,
				jobBoardView: this.jobBoardView,
				model: this.model,
				router: this.router,
			};
			var openingView = new Views.FullOpening(opts);
			this.$openingContainer.html(openingView.$el);
		},
	});

	Views.FullOpening = Views.Base.extend({
		template_id: "full-opening",
		events: {
			"click .grnhse-apply-button": "showApplicationForm",
		},
		prerenderHelper: function () {
			var remoteTag = this.model.getRemoteTag();
			this.tplVars = {
				urlPath: this.model.getUrlPath(),
				openingTitle: this.model.get("title"),
				locationName: this.model.getPrimaryOfficeLocation(),
				positionType: this.model.getTimeStatus(),
				allowsRemote: !!remoteTag,
				remoteType: remoteTag,
				jobPostBody: JSON.parse(this.model.get("content")),
				hasPuzzle: !!this.model.get("puzzleData"),
				puzzleBody: this.model.get("puzzleData") || null,
				applyButtonWords: this.model.get("metadata").general_interest
					? "Express Interest"
					: "Apply Now",
				jobsListPath:
					AoPS.bd.user_info.campus_id === "web" ? "/careers" : "/school/jobs",
			};
		},
		postrenderHelper: function () {
			if (typeof MathJax !== "undefined") {
				setTimeout(function () {
					MathJax.Hub.Queue([
						"Typeset",
						MathJax.Hub,
						document.querySelector(".initial-application-puzzle"),
					]);
				}, 0);
				this.router.setJobCrumb(
					this.tplVars.openingTitle,
					this.tplVars.jobSlug
				);
			}
		},
		showApplicationForm: function (e) {
			var id = this.model.get("id");
			$(e.target).addClass("hidden");

			/* eslint-disable-next-line no-undef */
			Grnhse.Config.IframeDefault.onLoad = "AoPS.fixSidebarAnimatedOnce(300)";
			/* eslint-disable-next-line no-undef */
			Grnhse.Iframe.load(id);
		},
	});

	Views.JobNotFound = Views.Base.extend({
		template_id: "job-not-found",
		className: "aops-panel error-panel",
	});

	Views.NoJobs = Views.Base.extend({
		template_id: "no-jobs",
		className: "aops-panel",
	});

	Views.NoJobsFilter = Views.Base.extend({
		template_id: "no-jobs-filter",
		className: "aops-panel",
	});

	return Views;
})(AoPS.Careers.Views || {});
